import AppIcon from '../../../components/AppIcon';

const TestHistoryPanel = ({ testHistory }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'delivered':
        return 'text-green-600 bg-green-100';
      case 'pending':
        return 'text-yellow-600 bg-yellow-100';
      case 'failed':
        return 'text-red-600 bg-red-100';
      default:
        return 'text-gray-600 bg-gray-100';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'delivered':
        return 'تم التسليم';
      case 'pending':
        return 'قيد الإرسال';
      case 'failed':
        return 'فشل';
      default:
        return 'غير معروف';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'delivered':
        return 'CheckCircle2';
      case 'pending':
        return 'Clock';
      case 'failed':
        return 'XCircle';
      default:
        return 'HelpCircle';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <AppIcon name="History" size={20} className="text-primary" />
          <h3 className="font-semibold text-foreground">سجل الاختبارات</h3>
        </div>
        <span className="text-sm text-muted-foreground">{testHistory?.length} اختبار</span>
      </div>
      {testHistory?.length === 0 ? (
        <div className="text-center py-8">
          <AppIcon name="Inbox" size={48} className="mx-auto text-muted-foreground mb-3" />
          <p className="text-muted-foreground text-sm">لا توجد اختبارات بعد</p>
        </div>
      ) : (
        <div className="space-y-3">
          {testHistory?.map((test) => (
            <div key={test?.id} className="border border-border rounded-lg p-4 hover:bg-muted/50 transition-colors">
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1">
                  <h4 className="font-medium text-foreground text-sm mb-1">{test?.template}</h4>
                  <p className="text-xs text-muted-foreground">إلى: {test?.recipient}</p>
                </div>
                <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(test?.status)}`}>
                  <AppIcon name={getStatusIcon(test?.status)} size={12} />
                  <span>{getStatusLabel(test?.status)}</span>
                </div>
              </div>

              <div className="flex items-center justify-between text-xs text-muted-foreground mt-3 pt-3 border-t border-border">
                <div className="flex items-center gap-1">
                  <AppIcon name="Mail" size={12} />
                  <span>{test?.client}</span>
                </div>
                <div className="flex items-center gap-1">
                  <AppIcon name="Clock" size={12} />
                  <span>{test?.sentAt}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TestHistoryPanel;